module.exports = __webpack_public_path__ + "static/media/percentage-dark.a0061ea3.svg";